/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import numeral from 'numeral';

const Comment = ({
  data: {
    commentId,
    title,
    date,
    text,
    imageUrl,
    emotionName,
    characterName,
    rating,
    numLikes,
    numComments,
    numShares,
    numEngagements
  },
  onImageLoad
}) => {
  const formatTitle = () => {
    return (
      <div className="tvt-reactions__comment-title-wrapper">
        <div className="tvt-reactions__comment-title">
          {title}
          {title ? (
            <span className="tvt-reactions__comment-title-separater">•</span>
          ) : null}
        </div>
        <div className="tvt-reactions__comment-date">
          {moment(date).format('MMMM DD, YYYY')}
        </div>
      </div>
    );
  };

  const formatCommentText = () => {
    return <div className="tvt-reactions__comment-text">{text}</div>;
  };

  const formatEmotionsAndRating = () => {
    const stars = [];

    for (let index = 1; index <= 5; index++) {
      stars.push(
        <FontAwesomeIcon
          key={Math.random()}
          className={`tvt-reactions__comment-rating-star ${
            index <= rating || 0 ? 'active' : 'inactive'
          }`}
          icon="star"
          size="1x"
        />
      );
    }

    const emotions = emotionName
      ? emotionName.split('|').map(e => {
          if (!e) {
            return null;
          }

          return (
            <div
              key={`${commentId}-${e}`}
              className="tvt-reactions__comment-emotion-tag"
            >
              {e}
            </div>
          );
        })
      : null;

    return (
      <div className="tvt-reactions__comment-emotions-rating-wrapper">
        {emotions}
        {characterName && (
          <div className="tvt-reactions__comment-character-tag">
            {characterName}
          </div>
        )}
        {rating !== null && (
          <div className="tvt-reactions__comment-rating">{stars}</div>
        )}
      </div>
    );
  };

  const formatEngagementRow = () => {
    return (
      <div className="tvt-reactions__comment-emotions-engagements-wrapper">
        <div className="tvt-reactions__comment-engagements-num-total">
          {numeral(numEngagements).format(',')} Engagements
        </div>
        <div className="tvt-reactions__comment-engagements-num">
          <FontAwesomeIcon
            className="tvt-reactions__comment-num-likes"
            icon={['far', 'heart']}
            size="1x"
          />
          <span>{numeral(numLikes).format(',')}</span>
        </div>
        <div className="tvt-reactions__comment-engagements-num">
          <FontAwesomeIcon
            className="tvt-reactions__comment-num-likes"
            icon={['far', 'comment']}
            size="1x"
          />
          <span>{numeral(numComments).format(',')}</span>
        </div>
        <div
          className={`tvt-reactions__comment-engagements-num ${
            !numShares && numShares !== 0 ? 'hide-icon' : ''
          }`}
        >
          <FontAwesomeIcon
            className="tvt-reactions__comment-num-likes"
            icon={['far', 'share-square']}
            size="1x"
          />
          <span>{numeral(numShares).format(',')}</span>
        </div>
      </div>
    );
  };

  return (
    <div className="tvt-reactions__comment-wrapper">
      {formatTitle()}
      {formatCommentText()}
      {imageUrl && (
        <img
          className="tvt-reactions__comment-image"
          src={imageUrl}
          alt="Comment"
          onLoad={onImageLoad}
        />
      )}
      {formatEmotionsAndRating()}
      {formatEngagementRow()}
    </div>
  );
};

Comment.propTypes = {
  data: PropTypes.shape({
    commentId: PropTypes.number.isRequired,
    title: PropTypes.string,
    date: PropTypes.string,
    text: PropTypes.string,
    imageUrl: PropTypes.string,
    numLikes: PropTypes.number,
    numComments: PropTypes.number,
    numShares: PropTypes.number,
    numEngagements: PropTypes.number,
    rating: PropTypes.number,
    emotionTags: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  contentType: PropTypes.string.isRequired
};

Comment.defaultProps = {
  data: {
    title: 'title',
    date: 'date',
    text: 'title',
    imageUrl: 'title',
    numLikes: 100,
    numComments: 100,
    numShares: 100,
    numEngagements: 100,
    emotionTags: [],
    rating: 0
  },
  contentType: 'show'
};

export default Comment;
